<template>
  <section id="section_01" class="relative z-30 w-full">
    <grey-background>
      <div class="shade absolute top-0 left-0 w-full h-screen bg-black z-20 pointer-events-none"></div>
      <div id="logo_container" class="container relative h-screen flex justify-center items-center pointer-events-none">
        <gears />
        <logo />
      </div>
      <section-scroll-button
        id="scroll_prompt"
        class="z-30 absolute"
        :class="$device.android || $device.ios ? 'mb-32' : 'mb-8'"
        @click.native="$emit('next-section')"
      />
    </grey-background>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Logo from "./Section01Logo";
import Gears from "./Section01Gears";
import SectionScrollButton from "../SectionScrollButton";
import GreyBackground from "../../section-backgrounds/GreyBackground";

export default {
  components: {
    Logo,
    Gears,
    SectionScrollButton,
    GreyBackground,
  },
  computed: {
    ...mapGetters({ isLoading: "loader/isLoading" }),
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.runButtonLoop();
      }
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin);
    gsap.registerPlugin(ScrollTrigger);
    this.setScrollAnimation();
    this.setShadeAnimation();
  },
  methods: {
    runButtonLoop() {
      gsap.from("#scroll_prompt", {
        duration: 2,
        delay: 1,
        onComplete: () => {
          gsap.to("#scroll_prompt", {
            scrollTrigger: {
              trigger: "#section_01",
              start: "0",
              end: "400",
              scrub: true,
            },
          });
        },
      });
    },
    setScrollAnimation() {
      gsap.to("#logo_container", {
        yPercent: "170",
        opacity: "0",
        scrollTrigger: {
          trigger: "#section_01",
          start: "0",
          end: "100% 10%",
          scrub: true,
        },
      });
    },
    setShadeAnimation() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#section_01",
            pin: ".shade",
            scrub: 1,
            start: "-100",
            end: "100% 80%",
          },
        })
        .fromTo(
          "#section_01" + " .shade",
          {
            opacity: "0",
            position: "fixed",
          },
          { opacity: 0 }
        )
        .to("#section_01" + " .shade", { opacity: "0" });
    },
  },
};
</script>

<style lang="postcss" scoped>
#section_01 {
  max-height: 100vh;
  height: 100vh;
  #scroll_prompt {
    bottom: 0;
  }
}

@media screen and (max-height: 450px) {
  #scroll_prompt {
    margin-bottom: 4rem;
  }
}
</style>